<template>
  <div class="invoice-purpose">
    <Form
      ref="purposeFrom"
      :model="purposeFrom"
      :rules="ruleInPurpose"
      :label-width="110"
      label-position="left"
    >
      <FormItem
        label="发票抬头："
        prop="titleSelectId"
        class="short"
        v-if="(dedicated && !purposeFrom.coverFileId) || company"
      >
        <Select
          placeholder="公司名称(可检索)"
          ref="title"
          v-model="purposeFrom.titleSelectId"
          @on-change="changeInvoiceComp"
          filterable
          remote
          :remote-method="remoteMethod"
          :loading="invioceLoading"
        >
          <Option
            v-for="(option, index) in optionsSelect"
            :value="option.value"
            :key="index"
          >{{option.label}}</Option>
        </Select>
      </FormItem>
      <FormItem
        v-if="(dedicated && !purposeFrom.coverFileId) || company"
        label="纳税人识别号："
        prop="identityCode"
        class="short"
      >
        <Input v-model="purposeFrom.identityCode" :maxlength="100" placeholder="社会统一信用代码"></Input>
      </FormItem>
      <FormItem
        v-if="dedicated && !purposeFrom.coverFileId"
        label="注册电话："
        prop="registerTel"
        class="short"
      >
        <Input v-model="purposeFrom.registerTel" :maxlength="15" placeholder="手机号码或固定电话（例如：0000-0000000）"></Input>
      </FormItem>
      <FormItem v-if="dedicated && !purposeFrom.coverFileId" label="注册地址：">
        <Input v-model="purposeFrom.registerAddress" :maxlength="200" placeholder="请输入公司注册地址"></Input>
      </FormItem>
      <FormItem v-if="dedicated && !purposeFrom.coverFileId" label="开户银行：">
        <Input v-model="purposeFrom.bankInfo" :maxlength="200" placeholder="请输入公司开户行"></Input>
      </FormItem>
      <FormItem v-if="dedicated && !purposeFrom.coverFileId" label="银行账户：">
        <Input v-model="purposeFrom.bankAccount" :maxlength="30" placeholder="请输入公司开户账号"></Input>
      </FormItem>
      <FormItem label="发票内容：">
        <span class="txt">家居产品</span>
      </FormItem>
      <FormItem label="发票金额：" class="marTop">
        <span class="price-red">{{currency(price, '¥', '2')}}</span>
        <span class="txt">（订单金额）</span>
      </FormItem>
      <FormItem label="收票人：" prop="receiverName" class="short">
        <Input v-model="purposeFrom.receiverName" :maxlength="200" placeholder="请输入收票人姓名"></Input>
      </FormItem>
      <FormItem label="收票人手机：" prop="receiverPhone" class="short">
        <Input v-model="purposeFrom.receiverPhone" :maxlength="11" placeholder="请输入收票人手机号，以便通知"></Input>
      </FormItem>
      <FormItem label="收票人地址：" prop="receiverAddress">
        <Input v-model="purposeFrom.receiverAddress" :maxlength="200" placeholder="请输入地址以便接收发票"></Input>
      </FormItem>
      <FormItem class="choiceBtn">
        <Button type="text" @click="chiocedAddressHandle">选择已有地址 <i style="font-size:12px;" class="iconfont icon-arrow-left"></i>  </Button>
      </FormItem>
      <FormItem label="发票须知：" class="notice">
        <p>1.开票金额为用户实际支付的金额</p>
        <p>2.未随箱寄出的纸质发票会在发货后10-15个工作日单独寄出</p>
        <p>3.单笔订单只支持开具一种类型的发票</p>
      </FormItem>
    </Form>
    <div class="uploadInvioceImg" v-if="dedicated">
      <z-upload
        v-if="ossKeys"
        :type="17"
        @success="successHandle"
        :maxSize="5120"
        :ossKey="ossKeys"
        :progressBar="true"
      >
        <div class="up-icon" v-if="!purposeFrom.coverFileId">
          <i class="iconfont icon-tupian"></i>
          <p>拍照上传</p>
        </div>
        <img v-else :src="ossUrl + purposeFrom.invoiceFile.key" alt>
      </z-upload>
    </div>
  </div>
</template>
<script>
import {
  REQUIRED_RULES,
  REQUIRED_RULES_CHANGE,
  NUM_LETTER_RULES,
  PHONE_RULES,
  PHONE_RULES_REQUIRE,
  NUM_NOQUERY_RULES,
  TEL_PHONE_RULES
} from "../../../constants/rules";
import emitter from "../../../mixins/emitter.js";
import ZUpload from "../../upload/upload.vue";
import _ from "lodash";
export default {
  name: "InvoicePurpose",
  mixins: [emitter],
  data() {
    return {
      purposeFrom: {
        title: "",
        titleSelectId: "",
        identityCode: "",
        registerTel: "",
        registerAddress: "",
        bankInfo: "",
        bankAccount: "",
        invoicePrice: "", //发票金额
        receiverName: "",
        receiverPhone: "",
        receiverAddress: "",
        addressId: null,
        type: 0,
        coverFileId: "",
        invoiceFile: {}
      },
      ruleInPurpose: {
        titleSelectId: REQUIRED_RULES_CHANGE,
        identityCode: NUM_LETTER_RULES,
        registerTel: TEL_PHONE_RULES,
        bankAccount: NUM_NOQUERY_RULES,
        receiverName: REQUIRED_RULES,
        receiverPhone: PHONE_RULES_REQUIRE,
        receiverAddress: REQUIRED_RULES
      }
    };
  },
  props: {
    invoiceFrom: {
      type: Object,
      default: function() {
        return {};
      }
    },
    invioceLoading: {
      type: Boolean,
      default: false
    },
    optionsSelect: {
      type: Array,
      default: function() {
        return [];
      }
    },
    // 选择公司时候接收的信息
    companyInfo: {
      type: Object,
      default: function() {
        return {};
      }
    },
    // 从当前地址选择的地址
    choicedAddress: {
      type: Object,
      default: function() {
        return {};
      }
    },
    /* 发票价格 */
    price: {
      type: [Number, String],
      default: ""
    },

    ossKeys: {
      type: Object,
      default: function() {
        return {};
      }
    },
    ossUrl: {
      type: String,
      default: ""
    }
  },
  components: { ZUpload },
  computed: {
    // 是否要显示专用
    dedicated() {
      if (this.invoiceFrom && this.invoiceFrom.invoiceType === 1) {
        return true;
      } else {
        return false;
      }
    },
    // 是否是单位
    company() {
      if (
        this.invoiceFrom &&
        this.invoiceFrom.invoiceType === 2 &&
        this.invoiceFrom.commomType === 2
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    remoteMethod(query) {
      if (query === "") return false;
      setTimeout(() => {
        this.selectChange(query);
      }, 200);
    },
    // 输入请求接口
    selectChange(query) {
      this.dispatch("ZInvoicelog", "selectHandle", query);
    },
    // 选择触发
    changeInvoiceComp(value) {
      this.dispatch("ZInvoicelog", "changeInvoice", value);
    },
    // 选择现有地址列表
    chiocedAddressHandle() {
      this.dispatch("ZInvoicelog", "chiocedAddress");
    },
    // 改变type
    changeType() {
      if (this.invoiceFrom && this.invoiceFrom.invoiceType === 1) {
        return 2;
      } else if (
        this.invoiceFrom &&
        this.invoiceFrom.invoiceType === 2 &&
        this.invoiceFrom.commomType === 1
      ) {
        return 0;
      } else if (
        this.invoiceFrom &&
        this.invoiceFrom.invoiceType === 2 &&
        this.invoiceFrom.commomType === 2
      ) {
        return 1;
      }
    },

    //  上传图片
    successHandle(file) {
      if (!file) return false;
      this.purposeFrom.coverFileId = file.data[0].id;
      this.purposeFrom.invoiceFile = file.data[0];
    }
  },
  watch: {
    price: function() {
      if(this.price) {
        this.purposeFrom.invoicePrice = this.price;
      }
    },
    companyInfo: function() {
      if (this.companyInfo) {
        this.purposeFrom.registerAddress = this.companyInfo.oploc || "";
        this.purposeFrom.identityCode =
          this.companyInfo.taxnumber || this.companyInfo.uncid;
      }
    },
    choicedAddress: function() {
      this.purposeFrom.receiverName = this.choicedAddress.userName;
      this.purposeFrom.receiverPhone = this.choicedAddress.userMobile;
      this.purposeFrom.receiverAddress = this.addressFilter(
        this.choicedAddress.detailAddress,
        "all"
      );
    },
    invoiceFrom: function() {
      if (this.invoiceFrom.invoiceType !== 1) {
        this.purposeFrom.coverFileId = "";
        this.purposeFrom.invoiceFile = {};
      }
    },
    resertInput() {
      this.$refs["purposeFrom"].resetFields();
      this.purposeFrom.coverFileId = "";
      this.purposeFrom.invoiceFile = {};
    }
  },
  created() {
    // 父组件触发submit提交
    this.$on("submitInvoice", () => {
      this.$refs["purposeFrom"].validate(valid => {
        if (valid) {
          this.purposeFrom.type = this.changeType();
          if (this.purposeFrom.coverFileId) {
            let newObj = _.pick(this.purposeFrom, [
              "invoicePrice",
              "receiverName",
              "receiverPhone",
              "receiverAddress",
              "addressId",
              "type",
              "coverFileId",
              "invoiceFile"
            ]);
            this.dispatch("ZInvoicelog", "submitInsert", newObj);
          } else {
            this.purposeFrom.type > 0 ? this.purposeFrom.title = this.companyInfo.entname : this.purposeFrom.title = '个人';
            this.dispatch("ZInvoicelog", "submitInsert", this.purposeFrom);
          }
          this.resertInput();
        } else {
          this.$Message.warning("请检查是否完成填写！");
        }
      });
    });

    // cencel
    this.$on("cencelInvoiceHandle", () => {
      this.resertInput();
    });
  }
};
</script>

